module.exports = __webpack_public_path__ + "img/path_12_mobile.caffae6b.jpg";